import { forwardRef, Th, Tr } from "@chakra-ui/react";

export const ImportRequestHeaderRow = forwardRef((_, ref) => (
  <Tr ref={ref}>
    <Th>Id</Th>
    <Th>Bestandsnaam</Th>
    <Th>Status</Th>
    <Th>Modus</Th>
    <Th>Inzendmoment</Th>
    <Th>Resultaat</Th>
    <Th>Rapport</Th>
    <Th>Acties</Th>
  </Tr>
));
